// import './App.css';
import { Route, Routes, useLocation, Navigate } from "react-router-dom";

import ErrorPageComp from "./CommanCom/ErrorPageComp";
import UserRoutes from "./PrivateRoutes/UserRoutes";
import LoginComp from "./AppCom/Login/LoginComp";
import DashboardComp from "./AppCom/Dashboard/DashboardComp";
import PolicyCom from "./AppCom/HR/PolicyCom";
import UserAttendanceCom from "./AppCom/Attendance/UserAttendanceCom";
import NewUserAttendance from "./AppCom/Attendance/Attandence_list";
import EmployeeListCom from "./AppCom/Employee/EmployeeListCom";
import AddEmployeeCom from "./AppCom/Employee/AddEmployeeCom";
import EditEmployeeCom from "./AppCom/Employee/EditEmployeeCom";
import ApprovetimesheetCom from "./AppCom/ApproveTimesheet/ApprovetimesheetCom";
import ProfileCom from "./AppCom/Employee/ProfileCom";
import ResetPassSendLink from "./AppCom/BulkEmail/ResetPassSendLink";
import NewPasswordCom from "./AppCom/Login/NewPasswordCom";
import ItCom from "./AppCom/IT/ItCom";

import SystemAllocationUpdateComp from "./AppCom/IT/SystemAllocationUpdateComp";
import HrRoutes from "./PrivateRoutes/HrRoutes";
import FeedNewsCom from "./AppCom/HR/FeedNewsCom";
import HolidayListCom from "./AppCom/HR/HolidayListCom";
import EmpLeaveCom from "./AppCom/Employee/EmpLeaveCom";
import MomentsQbsComp from "./AppCom/HR/MomentsQbsComp";
import QuoteCom from "./AppCom/HR/QuoteCom";
import ViewEmployeeCom from "./AppCom/Employee/ViewEmployeeCom";
import "./index.scss";
// import EmpAttendanceCom from "./AppCom/HR/EmpAttendanceCom";
// import LeaveApprovalComp from "./AppCom/HR/Approval/LeaveApprovalComp";
import AttendanceApprovalComp from "./AppCom/HR/Approval/AttendanceApprovalComp";
import LeaveApprovalComp from "./AppCom/HR/Approval/LeaveApprovalComp";

import QbsconnectTalkComp from "./AppCom/HR/QbsconnectTalkComp";
import UserDirectoryComp from "./AppCom/Employee/UserDirectoryComp";
import LocationComp from "./AppCom/HR/LocationComp";

import PermissionCom from "./AppCom/HR/PermissionCom";

import Skills from "./AppCom/HR/Skills/Skills";
import OnboardingList from "./AppCom/HR/onboarding/onboardingList";
import NewJoiningFrom from "./AppCom/HR/onboarding/JoiningFrom";
import EmailVerification from "./AppCom/HR/onboarding/EmailVerification";
import ReportAttendanceCom from "./AppCom/HR/Reports/ReportAttendanceCom";
import JoiningSuccessPage from "./AppCom/HR/onboarding/JoiningSuccessPage";
import ViewJoiningForm from "./AppCom/HR/onboarding/ViewJoiningForm";
import UserMenuComp from "./AppCom/HR/Menus/UserMenuComp";
import ItRoute from "./PrivateRoutes/ItRoute";
import UpdateUserProfileCom from "./AppCom/Employee/UpdateUserProfileCom";
import UserReportsComp from "./AppCom/HR/Reports/UserReportsComp";
import SystemActivity from "./CommanCom/SystemActivity";
import UserLoginReports from "./AppCom/HR/Reports/UserLoginReportsComp";
import SystemAllocationComp from "./AppCom/IT/SystemAllocationComp";
import SystemAllocationViewComp from "./AppCom/IT/SystemAllocationViewComp";
import RequestTeamForm from "./AppCom/Employee/RequestTeamForm";
import RequestTeamEditForm from "./AppCom/Employee/RequestTeamEditForm";
import RequestTeamViewForm from "./AppCom/Employee/RequestTeamViewForm";
import HiringTeamForm from "./AppCom/Employee/HiringTeamForm";
import RequestList from "./AppCom/Employee/RequestTeamList";
import PerfomanceAllocationList from "./AppCom/PerformanceManagement/PerfomanceAllocationList";
import HodPerfomanceAllocationList from "./AppCom/PerformanceManagement/HodPerfomanceAllocationList";
import PerformanceDashboard from "./AppCom/PerformanceManagement/PerformanceDashboard";
import HrKpiManagement from "./AppCom/PerformanceManagement/HrKpiManagement";
import HrKraManagement from "./AppCom/PerformanceManagement/HrKraManagement";
import ManagerPerformanceList from "./AppCom/PerformanceManagement/ManagerPerformanceList";
import PerformanceReview from "./AppCom/PerformanceManagement/PerformanceReview";
import HodPerformanceReview from "./AppCom/PerformanceManagement/HodPerformanceReview";
import AllNotifications from "./AppCom/Notifications/AllNotifications";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginComp />} />
        <Route path="/login" element={<LoginComp />} />
        <Route path="/check-logs" element={<SystemActivity />} />
        <Route path="/new-joining" element={<NewJoiningFrom />} />
        <Route path="/email-verify" element={<EmailVerification />} />
        <Route path="/joining-success" element={<JoiningSuccessPage />} />

        <Route
          path="/notifications"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="6">
              <AllNotifications />
            </HrRoutes>
          }
        />
        <Route
          path="/viewjoiningform"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="6">
              <ViewJoiningForm />
            </HrRoutes>
          }
        />
        <Route
          path="/dashboard"
          element={
            <UserRoutes header_title="DASHBOARD">
              <DashboardComp />
            </UserRoutes>
          }
        />
        <Route
          path="/attendance2"
          element={
            <UserRoutes header_title="DASHBOARD">
              <NewUserAttendance />
            </UserRoutes>
          }
        />
        <Route
          path="/attendance"
          element={
            <UserRoutes header_title="DASHBOARD">
              <UserAttendanceCom />
            </UserRoutes>
          }
        />
        <Route
          path="/user-directry"
          element={
            <UserRoutes header_title="DASHBOARD">
              <UserDirectoryComp />
            </UserRoutes>
          }
        />

        <Route
          path="/approvetimesheet"
          element={
            <UserRoutes header_title="DASHBOARD">
              <ApprovetimesheetCom />
            </UserRoutes>
          }
        />
        <Route
          path="/profile"
          element={
            <UserRoutes header_title="DASHBOARD">
              <ProfileCom />
            </UserRoutes>
          }
        />
        <Route
          path="/updateprofile"
          element={
            <UserRoutes header_title="DASHBOARD">
              <UpdateUserProfileCom />
            </UserRoutes>
          }
        />

        <Route path="/new-password" element={<NewPasswordCom />} />

        <Route
          path="/system-allocation-update/:id"
          exact={true}
          element={
            <ItRoute header_title="DASHBOARD" menu_id="6">
              <SystemAllocationUpdateComp />
            </ItRoute>
          }
        />
        <Route
          path="/system-allocation-view/:id"
          exact={true}
          element={
            <ItRoute header_title="DASHBOARD" menu_id="6">
              <SystemAllocationViewComp />
            </ItRoute>
          }
        />

        <Route
          path="/systeminformation"
          exact={true}
          element={
            <UserRoutes header_title="DASHBOARD">
              <ItCom />
            </UserRoutes>
          }
        />

        <Route
          path="/leave"
          element={
            <UserRoutes header_title="DASHBOARD">
              <EmpLeaveCom />
            </UserRoutes>
          }
        />

        <Route
          path="/policy"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="6">
              <PolicyCom />
            </HrRoutes>
          }
        />
        <Route
          path="/skills"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="7">
              <Skills />
            </HrRoutes>
          }
        />
        <Route
          path="/onboarding"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="31">
              <OnboardingList />
            </HrRoutes>
          }
        />
        <Route
          path="/RequestList"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="52">
              <RequestList />
            </HrRoutes>
          }
        />
        <Route
          path="/requestForm"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="52">
              <RequestTeamForm />
            </HrRoutes>
          }
        />
        <Route
          path="/HiringForm"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="52">
              <HiringTeamForm />
            </HrRoutes>
          }
        />
        <Route
          path="/requestEditForm"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="52">
              <RequestTeamEditForm />
            </HrRoutes>
          }
        />
        <Route
          path="/requestViewForm"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="52">
              <RequestTeamViewForm />
            </HrRoutes>
          }
        />
        <Route
          path="/hod/performance"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <HodPerfomanceAllocationList />
            </HrRoutes>
          }
        />
        <Route
          path="/Allocation"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <PerfomanceAllocationList />
            </HrRoutes>
          }
        />
        <Route
          path="/kPI"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <HrKpiManagement />
            </HrRoutes>
          }
        />
        <Route
          path="/KRA"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <HrKraManagement />
            </HrRoutes>
          }
        />
        <Route
          path="/manager/performance"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <ManagerPerformanceList />
            </HrRoutes>
          }
        />
        <Route
          path="/hod/performance-review/:employeeId/:deptId/:systemRole"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <HodPerformanceReview />
            </HrRoutes>
          }
        />
        <Route
          path="/manager/performance-review/:employeeId/:day/:month/:year/:date"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <PerformanceReview />
            </HrRoutes>
          }
        />

        <Route
          path="/PerformancePanel"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="55">
              <PerformanceDashboard />
            </HrRoutes>
          }
        />

        <Route
          path="/employeelist"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="8">
              <EmployeeListCom />
            </HrRoutes>
          }
        />

        <Route
          path="/addemployee"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="26">
              <AddEmployeeCom />
            </HrRoutes>
          }
        />
        <Route
          path="/editemployee"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="27">
              <EditEmployeeCom />
            </HrRoutes>
          }
        />
        <Route
          path="/viewemployee"
          exact={true}
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="27">
              <ViewEmployeeCom />
            </HrRoutes>
          }
        />

        <Route
          path="/emp-attendance-approval-list"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="9">
              <AttendanceApprovalComp />
            </HrRoutes>
          }
        />
        <Route
          path="/emp-leave-approval-list"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="9">
              <LeaveApprovalComp />
            </HrRoutes>
          }
        />

        <Route
          path="/resetpassword"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="10">
              <ResetPassSendLink />
            </HrRoutes>
          }
        />
        <Route
          path="/feed-news"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="11">
              <FeedNewsCom />
            </HrRoutes>
          }
        />
        <Route
          path="/momentsqbs"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="12">
              <MomentsQbsComp />
            </HrRoutes>
          }
        />
        <Route
          path="/quotelist"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="13">
              <QuoteCom />
            </HrRoutes>
          }
        />
        <Route
          path="/holidaylist"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="14">
              <HolidayListCom />
            </HrRoutes>
          }
        />
        <Route
          path="/qbsconnecttalklist"
          element={
            <HrRoutes header_title="DASHBOARD" menu_id="15">
              <QbsconnectTalkComp />
            </HrRoutes>
          }
        />
        <Route
          path="/location"
          element={
            <HrRoutes header_title="Location" menu_id="16">
              <LocationComp />
            </HrRoutes>
          }
        />
        <Route
          path="/permission"
          element={
            <HrRoutes header_title="Permission" menu_id="17">
              <PermissionCom />
            </HrRoutes>
          }
        />
        <Route
          path="/reports"
          element={
            <HrRoutes header_title="Permission" menu_id="17">
              <ReportAttendanceCom />
            </HrRoutes>
          }
        />

        <Route
          path="/usermenu"
          element={
            <HrRoutes header_title="Menu" menu_id="88">
              <UserMenuComp />
            </HrRoutes>
          }
        />
        <Route
          path="/userreports"
          element={
            <HrRoutes header_title="Menu" menu_id="61">
              <UserReportsComp />
            </HrRoutes>
          }
        />
        <Route
          path="/userloginreports"
          element={
            <HrRoutes header_title="Menu" menu_id="62">
              <UserLoginReports />
            </HrRoutes>
          }
        />

        <Route
          path="/create-official-email"
          exact={true}
          element={
            <ItRoute header_title="DASHBOARD" menu_id="6">
              <ItCom />
            </ItRoute>
          }
        />
        <Route
          path="/system-allocation"
          exact={true}
          element={
            <ItRoute header_title="DASHBOARD" menu_id="6">
              <SystemAllocationComp />
            </ItRoute>
          }
        />

        <Route path="*" exact={true} element={<ErrorPageComp />} />

        {/* updateinfo */}
      </Routes>
    </div>
  );
}

export default App;
